<div class="row form-group">
    <div class="col-xl-12 col-xxl-4">
        <label for="opacitySlider">opacity</label>
    </div>
    <div class="col-xl-12 col-xxl-8">
        <input type="range"
                class="opacity-slider custom-range"
                id="opacitySlider"
                [(ngModel)]="opacity"
                (ngModelChange)="formControlChanged()"
                min="0"
                max="100">
    </div>
</div>

